import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { usePageMeta } from "../../lib/usePageMeta";
import { BadgeCheck, Sparkles } from "lucide-react";

const fmtEur = (cents) => (cents / 100).toLocaleString("it-IT", { minimumFractionDigits: 0 });

export default function PlansPublic() {
  usePageMeta({
    title: "Piani e prezzi | Wattline",
    description: "Piani annuali Team, Business ed Energia con prova gratuita di 7 giorni: presenze, formazione, assistente AI e verifiche imprese in un'unica piattaforma.",
  });
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/public/plans").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-page" data-testid="plans-page">
      <header className="flex items-center justify-between px-6 sm:px-10 py-5 max-w-6xl mx-auto">
        <div className="text-lg font-semibold text-text-primary tracking-tight">Wattline</div>
        <Link to="/login" className="wl-btn wl-btn--ghost" data-testid="plans-login-link">Accedi</Link>
      </header>

      <main className="max-w-6xl mx-auto px-6 sm:px-10 pb-16">
        <div className="text-center mt-6 mb-8">
          <h1 className="text-3xl sm:text-4xl font-semibold text-text-primary tracking-tight">
            Un piano per come lavora il tuo team
          </h1>
          <p className="text-sm text-text-secondary mt-2">
            Prova gratuita di 7 giorni, senza carta. Nessun costo di attivazione.
          </p>
        </div>

        {!data ? (
          <div className="text-center text-sm text-text-muted py-12">Caricamento…</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 items-stretch">
            {data.plans.map((p) => {
              const highlighted = p.id === "business";
              return (
                <div key={p.id} data-testid={`plan-card-${p.id}`}
                     className={`relative flex flex-col p-6 rounded-2xl border bg-surface ${highlighted ? "border-accent shadow-lg" : "border-border"}`}>
                  {highlighted && (
                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 wl-badge wl-badge--warning flex items-center gap-1">
                      <Sparkles size={10} /> Consigliato
                    </span>
                  )}
                  <div className="text-lg font-semibold text-text-primary">{p.name}</div>
                  <div className="text-xs text-text-muted mt-1 min-h-[32px]">{p.tagline}</div>
                  <div className="mt-4 flex items-baseline gap-1">
                    <span className="text-3xl font-semibold text-text-primary" data-testid={`plan-price-${p.id}`}>
                      {fmtEur(Math.round(p.yearly_cents / 12))}€
                    </span>
                    <span className="text-sm text-text-muted">/mese</span>
                  </div>
                  <div className="text-[11px] text-text-muted mt-0.5" data-testid={`plan-billing-${p.id}`}>
                    Fatturazione annuale · {fmtEur(p.yearly_cents)}€/anno
                  </div>
                  <ul className="mt-5 space-y-2 flex-1">
                    {p.benefits.map((b, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-text-primary">
                        <BadgeCheck size={14} className="text-accent mt-0.5 flex-shrink-0" /> {b}
                      </li>
                    ))}
                  </ul>
                  <button type="button" data-testid={`plan-cta-${p.id}`}
                          onClick={() => navigate(`/signup?plan=${p.id}`)}
                          className={`mt-6 wl-btn w-full ${highlighted ? "wl-btn--primary" : "wl-btn--ghost"}`}
                          style={!highlighted ? { border: "1px solid var(--wl-border)" } : undefined}>
                    Prova gratis 7 giorni
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <p className="text-center text-xs text-text-muted mt-8">
          Utenti oltre il limite del piano: 48€/utente/anno · Fatturazione annuale · Disdici quando vuoi
        </p>
      </main>
    </div>
  );
}
